import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ViewerOrderProvider } from './context/ViewerOrderContext';
import { ReportingProvider } from './context/ReportingContext';
import theme from './theme';
import MainLayout from './components/MainLayout';
import Dashboard from './components/Dashboard';
import Viewer from './components/Viewer';
import AuthCallback from './components/AuthCallback';
import PrivacyPolicy from './pages/PrivacyPolicy';
// import Viewer from './pages/Viewer';

const ProtectedRoute = ({ children }) => {
  const formData = localStorage.getItem('userFormData');
  const formCompleted = sessionStorage.getItem('formCompleted');
  
  if (!formData || !formCompleted) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ViewerOrderProvider>
        <ReportingProvider>
          <Router basename="/demo">
            <Routes>
              <Route path="/viewer" element={
                <ProtectedRoute>
                  <Viewer />
                </ProtectedRoute>
              } />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/" element={<MainLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="auth/callback" element={<AuthCallback />} />
              </Route>
            </Routes>
          </Router>
        </ReportingProvider>
      </ViewerOrderProvider>
    </ThemeProvider>
  );
};

export default App;
